import { render, staticRenderFns } from "./Loading2.vue?vue&type=template&id=64f387b8&"
import script from "./Loading2.vue?vue&type=script&lang=js&"
export * from "./Loading2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports